export default __webpack_public_path__ + "shapes-small.png?d4e9dce9c67a17d5f7f5f0652c412b85";